import { Button, DropdownMenu, Icon, Spinner } from '@design';
import sharedStyles from '@terminal/components/chat/chat-input/shared-attachment-pill/SharedAttachmentPill.module.scss';
import { useDropdownAutoClose } from '@terminal/hooks/use-dropdown-auto-close/useDropdownAutoClose';
import { UploadAlert } from '@terminal/views/alfred/research/upload-alert/UploadAlert';
import { useUserUpload } from '@terminal/views/alfred/research/use-user-upload/useUserUpload';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SingleFile } from './SingleFile';
import styles from './UploadFileStatusDropdown.module.scss';

export const UploadFileStatusDropdown = () => {
  const { t } = useTranslation(['chat']);

  const { files, removeAllFiles } = useUserUpload(state => ({
    files: state.files,
    removeAllFiles: state.removeAllFiles,
  }));

  const { dropdownOpen, setDropdownOpen } = useDropdownAutoClose();

  const isUploading = files.some(file => file.status === 'uploading');
  const completeCount = files.filter(file => file.status === 'complete').length;

  const pillLabel = (() => {
    if (isUploading) {
      return t('chat:userUpload.uploading');
    }

    if (completeCount) {
      return t('chat:userUpload.attachmentsWithCount', {
        count: completeCount,
      });
    }

    return '';
  })();

  return (
    <>
      {pillLabel && !!files.length && (
        <DropdownMenu
          className={clsx(
            sharedStyles.attachmentDropdown,
            styles.styledDropdownMenu
          )}
          open={dropdownOpen}
          onOpenChange={setDropdownOpen}
          triggerNode={
            <div>
              <Button
                className={sharedStyles.attachmentButton}
                variant="tertiary"
                size="small"
              >
                <div className={sharedStyles.infoWrapper}>
                  {isUploading ? (
                    <Spinner size="small" />
                  ) : (
                    <Icon iconName="Paperclip" size={12} />
                  )}
                  {pillLabel && (
                    <span className={sharedStyles.pillLabel}>{pillLabel}</span>
                  )}
                </div>
                {!!completeCount && (
                  <Icon
                    iconName="Close"
                    onPointerDown={removeAllFiles}
                    size={12}
                  />
                )}
              </Button>
            </div>
          }
        >
          {files.map(i => (
            <div key={i.field_name}>
              <SingleFile {...i} />
            </div>
          ))}
        </DropdownMenu>
      )}
      <UploadAlert onViewDetails={() => setDropdownOpen(true)} />
    </>
  );
};
